import {
  clearHopRegistrationDobInputErrors,
  getBirthdateValidationError,
} from '../../account-details/js/validate-birthdate';
import { bindDobDisclaimerValidation } from '../../account-details/js/validate-dob-disclaimer';
import { requestSubmitButtonValidation, syncHopRegistrationSubmitButton } from './request-submit-button-validation';

if (typeof window !== 'undefined') {
  window.syncHopRegistrationSubmitButton = syncHopRegistrationSubmitButton;
}

export default function initHopRegistrationForm() {
  function clearBirthdateErrors() {
    const errorEl = document.querySelector('[data-valmsg-for="DateOfBirth"]');

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('field-validation-error');
      errorEl.classList.add('field-validation-valid');
    }

    clearHopRegistrationDobInputErrors();
  }

  function validateBirthdate() {
    const dayInput = document.getElementById('dob-day');
    const monthInput = document.getElementById('dob-month');
    const yearInput = document.getElementById('dob-year');
    const hiddenInput = document.getElementById('DateOfBirth');

    if (!dayInput || !monthInput || !yearInput || !hiddenInput) {
      return true;
    }

    const day = dayInput.value;
    const month = monthInput.value;
    const year = yearInput.value;
    const errorMessage = getBirthdateValidationError(day, month, year);

    if (!errorMessage) {
      clearBirthdateErrors();

      const formattedDay = String(day).padStart(2, '0');
      const formattedMonth = String(month).padStart(2, '0');
      hiddenInput.value = `${formattedDay}/${formattedMonth}/${year}`;

      requestSubmitButtonValidation();
      return true;
    }

    hiddenInput.value = '';
    clearBirthdateErrors();

    requestSubmitButtonValidation();
    return false;
  }

  function handleBirthdateBlur() {
    validateBirthdate();
  }

  function bindDateOfBirthListeners() {
    ['dob-day', 'dob-month', 'dob-year'].forEach((id) => {
      const input = document.getElementById(id);
      if (!input) return;

      input.addEventListener('blur', handleBirthdateBlur);
      input.addEventListener('input', validateBirthdate);
      input.addEventListener('keypress', (e) => {
        const char = String.fromCharCode(e.which || e.keyCode);
        if (!/\d/.test(char)) e.preventDefault();
      });
      input.addEventListener('paste', (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d+$/.test(paste)) e.preventDefault();
      });
    });
  }

  function prefillDateOfBirthFromHiddenInput() {
    const hiddenInput = document.getElementById('DateOfBirth');
    if (!hiddenInput?.value) return;

    const match = hiddenInput.value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (!match) return;

    const [, day, month, year] = match;
    const dayInput = document.getElementById('dob-day');
    const monthInput = document.getElementById('dob-month');
    const yearInput = document.getElementById('dob-year');

    if (dayInput) dayInput.value = String(day).padStart(2, '0');
    if (monthInput) monthInput.value = String(month).padStart(2, '0');
    if (yearInput) yearInput.value = year;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('hop-registration-form');
    if (!form) return;

    bindDateOfBirthListeners();
    prefillDateOfBirthFromHiddenInput();

    form.addEventListener('input', requestSubmitButtonValidation);
    form.addEventListener('change', requestSubmitButtonValidation);
    form.addEventListener('blur', requestSubmitButtonValidation, true);

    const dobDisclaimer = bindDobDisclaimerValidation(form);

    requestSubmitButtonValidation();

    form.addEventListener('submit', (e) => {
      if (dobDisclaimer.bound && !dobDisclaimer.isValid()) {
        e.preventDefault();
        return;
      }

      if (!validateBirthdate()) {
        e.preventDefault();
      }
    });
  });
}
